import { render } from "./forget-form.vue?vue&type=template&id=4a387ff7&scoped=true"
import script from "./forget-form.vue?vue&type=script&lang=js"
export * from "./forget-form.vue?vue&type=script&lang=js"

import "./forget-form.vue?vue&type=style&index=0&id=4a387ff7&lang=less&scoped=true"

import exportComponent from "/dev/shm/repo/piano-dp8c0m8ga1zm/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a387ff7"]])

export default __exports__